var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVoid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.52,
    height: 17.492,
    viewBox: "0 0 14.52 17.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-void",
    transform: "translate(3.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M280.571,389.2A3.427,3.427,0,1,0,284,392.63,3.431,3.431,0,0,0,280.571,389.2Zm1.239,3.942a.512.512,0,1,1-.725.725l-.515-.515-.515.515a.512.512,0,1,1-.725-.725l.515-.515-.515-.515a.512.512,0,0,1,.725-.725l.515.515.515-.515a.512.512,0,1,1,.725.725l-.515.515Zm0,0",
    transform: "translate(-272.811 -378.566)",
    fill: "#d93025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M7.761,9.681a4.393,4.393,0,0,1,1.053.128V2.4A2.407,2.407,0,0,0,6.41,0H-.928a2.407,2.407,0,0,0-2.4,2.4V12.742a2.407,2.407,0,0,0,2.4,2.4H3.511A4.387,4.387,0,0,1,7.761,9.681ZM-.675,2.04H6.231a.512.512,0,0,1,0,1.025H-.675a.513.513,0,0,1-.512-.512A.512.512,0,0,1-.675,2.04Zm0,1.759H5.206a.512.512,0,0,1,0,1.025H-.675a.513.513,0,0,1-.512-.512A.513.513,0,0,1-.675,3.8Zm0,1.759H6.194a.512.512,0,0,1,0,1.025H-.675a.513.513,0,0,1-.512-.512A.512.512,0,0,1-.675,5.557ZM.994,13.165H-.675a.513.513,0,0,1-.512-.512.513.513,0,0,1,.512-.512H.994a.512.512,0,1,1,0,1.025Zm0,0",
    transform: "translate(0 0)",
    fill: "#d93025"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVoid);
export default __webpack_public_path__ + "static/media/ic-void.0198246a.svg";
export { ForwardRef as ReactComponent };